import React from 'react';
import Icon1 from '../assets/images/icon-1-min.png';
import Icon5 from '../assets/images/icon-5-min.png';
import Icon3 from '../assets/images/icon-3-min.png';

import { Card, CardContent, Typography, Box, Grid } from '@mui/material';

// Las imágenes y los datos de los servicios
const services = [
  {
    image: Icon1,
    title: '¿Qué son Polímeros?',
    caption: 'Conoce más sobre los plásticos',
    content:
      'Descubre qué son los polímeros, su importancia en la vida diaria y los desafíos que enfrentan. 🌍✨',
  },
  {
    image: Icon5,
    title: '¿Cuál es su problemática?',
    caption: 'Conoce su impacto',
    content:
      'Conoce cómo los plásticos afectan al medio ambiente y qué podemos hacer para reducir su impacto. ♻️🌱',
  },
  {
    image: Icon3,
    title: 'Certifica tu conocimiento',
    caption: 'Certifícate y toma acciones',
    content:
      'Demuestra lo que sabes sobre polímeros y obtén tu certificación. 📚✅',
  },
];

const CardsSection = () => {
  return (
    <Box sx={{ backgroundColor: '#f0f0f0', py: { xs: 4, md: 6 }, width: '100%' }}>
      <Box sx={{ width: "100%", maxWidth: 1200, mx: "auto", px: { xs: 2, sm: 3 } }}>
        <Grid container spacing={{ xs: 2.5, md: 3.5 }} sx={{ justifyContent: 'center', alignItems: 'stretch' }}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: "100%", borderRadius: 2.5 }}>
                <Box
                  component="img"
                  src={service.image}
                  alt={service.title}
                  sx={{
                    width: { xs: 54, md: 64 },
                    height: { xs: 54, md: 64 },
                    objectFit: 'cover',
                    mt: 2.5,
                  }}
                />
                <CardContent sx={{ textAlign: 'center', mt: -1, px: { xs: 2, md: 3 } }}>
                  <Typography variant="h5" sx={{ fontWeight: 700, fontSize: { xs: "1.2rem", md: "1.4rem" } }}>
                    {service.title}
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    {service.caption}
                  </Typography>
                  <Typography variant="body1" sx={{ px: 1, mt: 1.25, color: "text.secondary" }}>{service.content}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default CardsSection;
